import { useCallback, useEffect, useState } from "react";

import client from "../../client";
import handleApiError from "../../../hooks/handleApiError";

const useFetchClassStudents = (classId, page, setPagination) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setData(null);
    setPagination(null);

    try {
      const { data } = await client.get(
        `/classes/${classId}/students?page=${page}`
      );

      setData(data?.data);
      if (data?.pagination) setPagination(data?.pagination);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, [classId, page, setPagination]);

  useEffect(() => {
    if (classId) fetchData();
  }, [fetchData, classId]);

  return [loading, data];
};

export default useFetchClassStudents;
